export function isCloudflareImage(url: string): boolean {
  return !!url?.includes("https://imagedelivery.net/");
}

export function getCloudflareFullImageUrl(url: string): string {
  if (!isCloudflareImage(url)) {
    return url;
  }

  return url
    .replace("/public", "")
    .replace(/\/w=\d{2,4}$/, "")
    .concat("/public");
}

export function getCloudflareResizedImageUrl(
  url: string,
  size: number
): string {
  if (!isCloudflareImage(url)) {
    return url;
  }

  return url
    .replace("/public", "")
    .replace(/\/w=\d{2,4}/, "")
    .concat(`/w=${size}`);
}
